import { createSelector } from '@reduxjs/toolkit'
import { getNestedProperty } from '@opallabs/lambda'
import { getJsonApiUsers, getMe, getUser } from '../../getters'
import { selectAvatars } from './avatars'

export const selectMe = createSelector([getMe], (me) => me)

export const selectUsers = createSelector([getJsonApiUsers], (users) => users)

export const selectUser = createSelector([getUser], (user) => user)

export const selectCurrentUserAvatarUuid = createSelector(
  [selectMe, selectAvatars],
  (currentUser) => {
    if (currentUser === undefined) return null
    const avatarUuid = currentUser?.avatarAssetReferenceUuid

    return typeof avatarUuid === 'string' ? avatarUuid : null
  }
)

export const selectUserWithAvatar = createSelector(
  [selectUser, selectAvatars],
  (user, avatars) => {
    const userAvatarId = getNestedProperty(
      user,
      'relationships',
      'avatar',
      'id'
    )
    const userAvatar = userAvatarId ? avatars[userAvatarId] : undefined
    if (user === undefined) {
      return undefined
    }
    return {
      ...user,
      avatar: userAvatar || null,
    }
  }
)

export const selectUsersToArray = createSelector(
  [selectUsers, selectAvatars],
  (users, avatars) =>
    Object.values(users || {}).map((user) => ({
      ...user,
      avatar: Object.values(avatars || {}).find(
        (avatar) =>
          avatar.id ===
            getNestedProperty(user, 'relationship', 'avatar', 'id') || null
      ),
    }))
)

export const selectUserIds = createSelector([selectUsers], (users) => {
  if (!users || Object.keys(users).length === 0) return []
  return Object.values(users).map((user) => parseInt(user.id, 10))
})

export const selectUsersWithoutViewers = createSelector(
  [selectUsersToArray],
  (users) => users.filter((user) => user.role_system_name !== 'view_only')
)
